'use strict';

class Tile {

  constructor() {

    this.handleContactPresseTile();
  }

  handleContactPresseTile() {

    $('.tile-d-contact-presse').bind('click', function (e) {
      e.preventDefault()
      if (!$('.contact-accordion').hasClass('open')) {
        $('.contact-accordion').addClass('open');
        $(this).css('margin-bottom', $('.contact-accordion').outerHeight() + 'px');
      } else {
        $('.contact-accordion').removeClass('open');
        $(this).css('margin-bottom', '');
      }
    });

    $('.contact-accordion').bind('click', function (e) {
      e.preventDefault()
      if (!$(this).hasClass('open')) {
        $(this).addClass('open');
      }
    });

    $('.contact-mail').bind('click', function (e) {
      e.preventDefault();
      window.location.assign($(this).attr('data-href'));
    });
  }
}

export default Tile;



// WEBPACK FOOTER //
// ./scripts/tile/tile.js